import React, { useState, useEffect, use } from "react";
import { Button, Input, Row, Col, Modal } from 'antd';
import Autocomplete from 'react-google-autocomplete';
import { GoogleApiWrapper } from 'google-maps-react';
import { MispichosVars } from "../../utils/Mispichoshelper";

// Mapa
import Leaflet from '../map/Leaflet';

const AddressAutoComplete = ({ loading, show, setShow, receiveAdress }) => {

  // const [loading, setLoading] = useState(loading);
  // const [showModal, setShowModal] = useState(show);

  // Map
  const [latitud, setLatitud] = useState(0);
  const [longitud, setLongitud] = useState(0);

  // Address
  const [localidad, setLocalidad] = useState(null);
  const [piso, setPiso] = useState(null);
  const [dpto, setDpto] = useState(null);
  const [partido, setPartido] = useState(null);
  const [entre_calles, setEntreCalles] = useState(null);
  const [barrio, setBarrio] = useState(null);
  const [ciudad, setCiudad] = useState(null);
  const [pais, setPais] = useState(null);
  const [calle, setCalle] = useState(null);
  const [altura, setAltura] = useState(null);
  const [cp, setCp] = useState(null);
  const [placeId, setPlaceId] = useState(null);

  const loadAddress = (place) => {

    /**
     * DATOS PRECARGADOS
     * 
     * cityLat
     * cityLng
     * calle
     * altura
     * cod_postal
     * barrio
     * ciudad
     * localidad
     * partido
     * pais
     * 
     * DATOS A COMPLETAR OPCIONALMENTE
     * 
     * piso
     * dpto
     * entre_calles
     * 
     */

    setLatitud(place.geometry.location.lat());
    setLongitud(place.geometry.location.lng());
    setPlaceId(place.place_id);

    // Datos de la dirección
    for (var i = 0; i < place.address_components.length; i++) {

      var value = place.address_components[i].short_name;
      var types = place.address_components[i].types ?? [];

      if (types.includes("postal_code")) setCp(value);
      if (types.includes("route")) setCalle(value);
      if (types.includes("street_number")) setAltura(value);
      if (types.includes("sublocality_level_1") || types.includes("sublocality")) setBarrio(value);
      if (types.includes("locality")) setLocalidad(value);
      if (types.includes("administrative_area_level_2")) setPartido(value);
      if (types.includes("country")) setPais(place.address_components[i].long_name);

      if (types.includes("administrative_area_level_1")) {
        var pos_borrar = value.toLowerCase().indexOf("provincia de ");
        if (pos_borrar !== -1) value = value.substring(13);
        setCiudad(value);
      }

    }
  }

  const sendAddress = () => {

    if (!validateFields()) return;

    // FORMATO DEL DOMICILIO PARA BACkEND
    var address = {
      // DATOS PRECARGADOS
      placeId: placeId,
      cityLat: latitud,
      cityLng: longitud,
      calle: calle,
      altura: altura,
      cod_postal: cp,
      barrio: barrio,
      ciudad: ciudad,
      localidad: localidad,
      partido: partido,
      pais: pais,
      // OPCIONALES
      piso: piso,
      dpto: dpto,
      entre_calles: entre_calles
    }
    // Enviar domicilio al padre
    receiveAdress(address);
  }

  const validateFields = () => {

    if (!calle || calle === '') { Modal.warning({ content: 'Calle no puede estar vacio' }); return false; }
    if (!altura || altura === '') { Modal.warning({ content: 'Altura no puede estar vacio' }); return false; }
    if (!cp || cp === '') { Modal.warning({ content: 'codigo postal no puede estar vacio' }); return false; }
    if (!barrio || barrio === '') { Modal.warning({ content: 'Barrio no puede estar vacio' }); return false; }
    if (!placeId || placeId === '') { Modal.warning({ content: 'No se ha podido obtener el ID de la dirección' }); return false; }

    return true;
  }

  return (
    <Modal
      title="Alta domicilio"
      visible={show}
      onOk={() => sendAddress()}
      onCancel={() => setShow(false)}
      style={{ minWidth: '45vw' }}
      footer={[
        <Button type="danger" loading={loading} onClick={() => setShow(false)}>
          Cancelar
        </Button>,
        <Button type="primary" loading={loading} onClick={() => sendAddress()}>
          Agregar nuevo domicilio
        </Button>,
      ]}
    >
      {/* FOMRULARIO */}
      <div className="container">
        <Row gutter={[10, 10]}>
          <Col span={24}>
            <fieldset>
              <label htmlFor="feDomicilio">Calle y Altura (No escribas el piso ni el interior.)</label>
              <Autocomplete
                placeholder="Buscar dirección"
                onPlaceSelected={(place) => loadAddress(place)}
                types={['address']}
                componentRestrictions={{ country: "ar" }}
              />
            </fieldset>
          </Col>
        </Row>
        <Row gutter={[10, 10]}>
          <Col span={12}>
            <fieldset>
              <label htmlFor="feDomicilioPiso">Calle <span style={{ color: 'red' }}>*</span></label>
              <Input
                type="text"
                value={calle}
                disabled
              />
            </fieldset>
          </Col>
          <Col span={12}>
            <fieldset>
              <label htmlFor="feDomicilioPiso">Altura <span style={{ color: 'red' }}>*</span></label>
              <Input
                type="text"
                value={altura}
                disabled
              />
            </fieldset>
          </Col>
        </Row>
        <Row gutter={[10, 10]}>
          <Col span={12}>
            <fieldset>
              <label htmlFor="feDomicilioPiso">Barrio <span style={{ color: 'red' }}>*</span></label>
              <Input
                type="text"
                value={barrio}
                onChange={(e) => setBarrio(e.target.value)}
              />
            </fieldset>
          </Col>
          <Col span={12}>
            <fieldset>
              <label htmlFor="feDomicilioCP">CP: <span style={{ color: 'red' }}>*</span></label>
              <Input
                id="feDomicilioCP"
                type="tel"
                placeholder="0000"
                onChange={(e) => setCp(e.target.value)}
                value={cp}
                required
              />
            </fieldset>
          </Col>
        </Row>
        <Row gutter={[10, 10]}>
          <Col span={12}>
            <fieldset>
              <label htmlFor="feDomicilioPiso">Piso</label>
              <Input
                id="feDomicilioPiso"
                type="tel"
                placeholder="numero"
                value={piso}
                onChange={(e) => setPiso(e.target.value)}
                required
              />
            </fieldset>
          </Col>
          <Col span={12}>
            <fieldset>
              <label htmlFor="feDomicilioDepartamento">Dpto</label>
              <Input
                id="feDomicilioDepartamento"
                type="text"
                value={dpto}
                onChange={(e) => setDpto(e.target.value)}
                required
              />
            </fieldset>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <fieldset>
              <label htmlFor="feDomicilioPiso">Entre calles</label>
              <Input
                type="text"
                value={entre_calles}
                onChange={(e) => setEntreCalles(e.target.value)}
                required
              />
            </fieldset>
          </Col>
        </Row>
        <Row gutter={[10, 10]}>
          {
            latitud !== 0 &&
            <fieldset>
              <div style={{ height: 250, width: "100%", padding: "20px 10px" }}>
                <Leaflet lat={latitud} lng={longitud} id={"mapAdressAutoComplete"} />
              </div>
            </fieldset>
          }
        </Row>
      </div >
    </Modal>
  )
}
export default GoogleApiWrapper({ apiKey: MispichosVars.GMAPS_KEY, libraries: ['places'] })(AddressAutoComplete);